import React from "react";
import { useMediaQuery } from "react-responsive";

const Margin = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  return <div className="margin" style={{ height: `${isMobile ? content.mobileHeight : content.height}px` }} />;
};

export default Margin;
